import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { AutoJobMatchSettingsComponent } from './auto-job-match-settings.component';

const routes: Routes = [
  {
    path: '',
    component: AutoJobMatchSettingsComponent,
    data: { title: 'Job Combination Settings' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AutoJobMatchRoutingModule {}

@NgModule({
  imports: [
    AutoJobMatchRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [AutoJobMatchSettingsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AutoJobMatchSettingsModule {}
